import { useState } from "react";
import React from "react";
import { MaterialReactTable } from "material-react-table";
import { MenuItem, Popover } from '@mui/material';
import { useDispatch } from "react-redux";
import { ToastContainer } from "react-toastify";
import { unsubscribeOffer } from "./constants/DocumentTableFunctions";
import CommonModal from "../Utils/CommonModal";
import { Loader } from "../Utils/Loader";
import { Box } from "@mui/material";
import { getStatusLabel } from "../Utils/DecideStatus";
import { getCellStyle } from "../Utils/DecideColor";
import { useNavigate } from "react-router-dom";
import { customerIdData, showPopUp } from "./constants/constantFunctionsView";
import moment from "moment";
import { subscriptionColumns } from "./constants/SubscriptionColoumn";
import { Card, CardBody, Col, Container, Row } from "reactstrap"
import { formatCellValue, formatDateForDisplay } from "../Utils/UtilityFunctions";
import StatusBadge from "./StatusBadge";
export default function ViewSubscription({ offer, customerData, subscriptionPermission }) {
    const [subscriptionId, setSubscriptionId] = useState('');
    const [messageForPopUp, setMessageForPopUp] = useState('');
    const [loading, setLoading] = useState(false);
    const [openPopUp, setOpenPopUp] = useState(false);
    const [anchorEl, setAnchorEl] = useState(null);
    const [activeRow, setActiveRow] = useState(null);
    const handlePopoverOpen = (event, row) => {
        setAnchorEl(event.currentTarget);
        setActiveRow(row?.original);
    };
    const handlePopoverClose = () => {
        setAnchorEl(null);
        setActiveRow(null);
    };
    const isPopoverOpen = Boolean(anchorEl);
    const customerId = customerIdData();
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const classifiedOffers = customerData.subscriptionList?.map(subscription => {
        const baseOffers = subscription.subscribedOffers
            .filter(offer => !offer.addOnOffer)
            .map(baseOffer => ({ ...baseOffer, subscriptionId: subscription.subscriptionId }));
        const addonOffers = subscription.subscribedOffers
            .filter(offer => offer.addOnOffer)
            .map(addonOffer => ({ ...addonOffer, subscriptionId: subscription.subscriptionId }));
        return { baseOffers, addonOffers };
    });
    const allBaseOffers = classifiedOffers?.flatMap(offer => offer.baseOffers) || [];
    const allAddonOffers = classifiedOffers?.flatMap(offer => offer.addonOffers) || [];
    const baseOffersWithAddons = allBaseOffers.map(baseOffer => ({
        ...baseOffer,
        addOnOffers: allAddonOffers.filter(addon => addon.subscriptionId === baseOffer.subscriptionId)
    }));
    const getSubscriptionId = (offerCode) => {
        if (Array.isArray(customerData.subscriptionList)) {
            const subscription = customerData.subscriptionList.find(sub => sub.subscribedOffers && sub.subscribedOffers.some(offer => offer.offerCode === offerCode));
            return subscription ? subscription.subscriptionId : null;
        }
        return null;
    }
    return (
        <React.Fragment>
            <ToastContainer position="top-center" />
            {baseOffersWithAddons.length > 0 ?

                    <>
                        {/* <div className="d-flex flex-column flex-md-row mt-3">
                            <h5 className="rv-page-title p-1">
                                {"Subscriptions List"}
                            </h5>
                        </div> */}
                        <div className="mb-3 mt-1 border table-responsive">
                            {baseOffersWithAddons.length > 0 ? (
                                <MaterialReactTable
                                    columns={subscriptionColumns}
                                    data={baseOffersWithAddons}
                                    enableDensityToggle={false}
                                    enableColumnActions={true}
                                    enableExpanding={true}
                                    renderTopToolbar={false}
                                    enableRowActions={subscriptionPermission?.has("unsubscribe")}
                                    initialState={{ columnOrder: undefined }}
                                    getRowCanExpand={(row) => row.original.addOnOffers && row.original.addOnOffers.length > 0}

                                    muiTableDetailPanelProps={{
                                        sx: {
                                            fontFamily: "Inter,sans-serif",
                                        },
                                    }}
                                    columnSizingMode="fixed"
                                    muiTableBodyCellProps={{
                                        sx: {
                                            whiteSpace: 'normal', // allow wrapping
                                            wordBreak: 'break-word', // wrap long words too
                                            lineHeight: 1.4, // for better readability
                                        },
                                    }}
                                    displayColumnDefOptions={{
                                        'mrt-row-actions': {
                                            header: '',
                                            enableHiding: true,
                                            size: 52,
                                        },
                                    }}
                                    icons={{
                                        DragHandleIcon: () => <i className="ri-drag-move-fill ms-3" />,
                                    }}
                                    renderExpandIcon={({ expanded }) => (
                                        <Box
                                            component="svg"
                                            className={`MuiSvgIcon-root MuiSvgIcon-fontSizeMedium css-i4bv87-MuiSvgIcon-root expand-icon ${expanded ? 'expanded' : ''
                                                }`}
                                            focusable="false"
                                            aria-hidden="true"
                                            viewBox="0 0 24 24"
                                            data-testid="ExpandMoreIcon"
                                        >
                                            <path d="M16.59 8.59 12 13.17 7.41 8.59 6 10l6 6 6-6z" />
                                        </Box>
                                    )}
                                    renderRowActionMenuItems={({ closeMenu, row }) => [
                                        subscriptionPermission && subscriptionPermission?.has("unsubscribe") ? (
                                            <MenuItem disabled={row.original.status === "CANCEL"} key="view" onClick={() => {
                                                setMessageForPopUp(`Are you sure you want to cancel this subscription "${row.original.offerName}"?`);
                                                showPopUp(row, setSubscriptionId, setOpenPopUp, openPopUp);
                                                closeMenu();
                                            }}>
                                                <i className='ri ri-delete-bin-5-line me-2 text-danger' />
                                                Cancel Subscription
                                            </MenuItem>
                                        ) : null,
                                        !row.original.addOnOffer ? (
                                            <MenuItem disabled={row.original.status === "CANCEL"} className='row-options' key="subscribe" onClick={() => {
                                                // const id = getSubscriptionId(row.original.offerCode);
                                                navigate(`/add-on/${customerId}`, { state: { subscriptionId: row.original.subscriptionId } });
                                            }}>
                                                <i className="ri-add-line me-2"></i> Add On
                                            </MenuItem>
                                        ) : null,
                                        !row.original.addOnOffer ? (
                                            <MenuItem disabled={row.original.status === "CANCEL"} className='row-options' key="change" onClick={() => {
                                                navigate(`/change-offer/${customerId}`, { state: { offerCode: row.original.offerCode, subscriptionIdOfCustomer: row.original.subscriptionId } });
                                            }}>
                                                <i className="ri-exchange-line me-2"></i> Change Offer
                                            </MenuItem>
                                        ) : null,
                                    ]}
                                    renderDetailPanel={({ row }) => (
                                        <Box className=''>
                                            {row.original.addOnOffers && row.original.addOnOffers.length > 0 ? (
                                                <>
                                                    <MaterialReactTable
                                                        columns={[
                                                            // 1) Placeholder column to match parent's row-action / leading column space
                                                            {
                                                                id: '__placeholder',
                                                                header: '',
                                                                accessorFn: () => '',
                                                                enableColumnActions: false,
                                                                enableSorting: false,
                                                                enableHiding: false,
                                                                size: 50,
                                                                Cell: () => null,
                                                            },
                                                            // 2) Then the actual columns for the add-on table (same order/sizes as parent)
                                                            {
                                                                accessorKey: 'actions',
                                                                header: '',
                                                                Cell: ({ row }) => (
                                                                    <>
                                                                        <i
                                                                            className='ri-more-2-fill me-2 text-black-50 fs-4 ms-0'
                                                                            onClick={(e) => handlePopoverOpen(e, row)}
                                                                            style={{ cursor: 'pointer' }}
                                                                        />
                                                                        <Popover
                                                                            open={Boolean(anchorEl)}
                                                                            anchorEl={anchorEl}
                                                                            onClose={handlePopoverClose}
                                                                            anchorOrigin={{
                                                                                vertical: 'bottom',
                                                                                horizontal: 'left',
                                                                            }}
                                                                        >
                                                                            <Box p={1} >
                                                                                <MenuItem disabled={activeRow?.status === "CANCEL"} key="view" onClick={() => {
                                                                                    setMessageForPopUp(`Are you sure you want to cancel this subscription "${row.original.offerName}"?`);
                                                                                    showPopUp(row, setSubscriptionId, setOpenPopUp, openPopUp);

                                                                                }}>
                                                                                    <i className='ri ri-delete-bin-5-line me-2 text-danger' />
                                                                                    Cancel Subscription
                                                                                </MenuItem>
                                                                            </Box>
                                                                        </Popover>
                                                                    </>
                                                                ),
                                                                size: 60,
                                                            },
                                                            {
                                                                accessorKey: 'subscriptionId',
                                                                header: 'Subscription ID',
                                                                size: 200,
                                                                Cell: ({ cell }) =>
                                                                    formatCellValue(cell.getValue(), (val) => (
                                                                        <Box sx={{ display: 'flex', justifyContent: 'flex-start' }}>{val}</Box>
                                                                    )),
                                                            },
                                                            {
                                                                accessorKey: 'offerName',
                                                                header: 'Offer Name',
                                                                size: 200,
                                                                Cell: ({ cell }) =>
                                                                    formatCellValue(cell.getValue(), (val) => (
                                                                        <Box sx={{ display: 'flex', justifyContent: 'flex-start' }}>{val}</Box>
                                                                    )),
                                                            },
                                                            {
                                                                accessorKey: 'validFrom',
                                                                header: 'Offer Starts',
                                                                size: 150,
                                                                Cell: ({ cell }) => formatCellValue(cell.getValue(), (val) => moment(val).format('DD MMM YYYY')),
                                                            },
                                                            {
                                                                accessorKey: 'validTo',
                                                                header: 'Offer Ends',
                                                                size: 150,
                                                                Cell: ({ cell }) => formatCellValue(cell.getValue(), (val) => moment(val).format('DD MMM YYYY')),
                                                            },
                                                            {
                                                                accessorKey: 'status',
                                                                header: 'Status',
                                                                size: 150,
                                                                Cell: ({ cell }) => <StatusBadge value={cell.getValue()} />,
                                                            },
                                                            {
                                                                accessorKey: 'addOnOffer',
                                                                header: 'Type',
                                                                size: 150,
                                                                Cell: ({ cell }) => (cell.getValue() ? 'Add-On' : 'Base Offer'),
                                                            },
                                                            {
                                                                accessorKey: 'serviceBarred',
                                                                header: 'Service Barred',
                                                                size: 150,
                                                                Cell: ({ cell }) => (cell.getValue() ? 'Yes' : 'No'),
                                                            },
                                                        ]}
                                                        data={row.original.addOnOffers}
                                                        enableHeader={false}
                                                        enableColumnOrdering={false}
                                                        enableColumnActions={false}
                                                        enableExpanding={false}
                                                        enableDensityToggle={false}
                                                        enableTopToolbar={false}
                                                        enableBottomToolbar={false}
                                                        muiTableHeadCellProps={{
                                                            sx: { display: 'none' }  // Hide the header cells
                                                        }}
                                                        muiTableHeadProps={{
                                                            sx: { display: 'none' }  // Hide the header row
                                                        }}
                                                        icons={{
                                                            DragHandleIcon: () => <i className="ri-drag-move-fill ms-3" />,
                                                        }}
                                                        columnSizingMode="fixed"
                                                        muiTableBodyCellProps={{
                                                            sx: {
                                                                whiteSpace: 'normal', // allow wrapping
                                                                wordBreak: 'break-word', // wrap long words too
                                                                lineHeight: 1.4, // for better readability
                                                            },
                                                        }}

                                                        muiTableBodyProps={{
                                                            sx: {
                                                                fontFamily: "Inter,sans-serif",
                                                            },
                                                        }}
                                                        displayColumnDefOptions={{
                                                            'mrt-row-actions': {
                                                                header: '',
                                                                enableHiding: true,
                                                                size: 0,
                                                            },
                                                        }}
                                                    />
                                                </>
                                            ) : (
                                                <p className="d-flex justify-content-start ms-5">
                                                    <span className="ms-5">No Add-On Offers available for the above Base Offer</span>
                                                </p>
                                            )}
                                        </Box>
                                    )}
                                />
                            ) : null}
                        </div>
                    </>
                : null}
            {openPopUp && (
                <CommonModal
                    open={openPopUp}
                    toggle={() => setOpenPopUp(!openPopUp)}
                    messageForPopUp={messageForPopUp}
                    buttonText={"Yes, Cancel It"}
                    modalAction={() => {
                        unsubscribeOffer(customerData, customerId, subscriptionId, setLoading, dispatch);
                        setOpenPopUp(!openPopUp);
                    }}
                    modalHeader="Cancel Subscription"
                />
            )}
            {loading && <Loader />}
        </React.Fragment>
    );
}
